import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Card, Row, Col, Nav } from 'react-bootstrap'
import '../../../../node_modules/react-vis/dist/style.css';
//import '../node_modules/react-vis/dist/style.css';
import {XYPlot, VerticalBarSeries, VerticalGridLines, HorizontalGridLines, XAxis, YAxis} from 'react-vis';

class LineChart extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
  
        };
      } 
  
      static defaultProps = {
      }
  
      componentDidMount(){
      }
  
      onItemSelectionChanged = (rowId) => {
  
      }

      render(){
  
        const data = [
          {x: '< 1 ', y: 8},
          {x: '2', y: 5},
          {x: '3', y: 4},
          {x: '4', y: 9},
          {x: '5', y: 1},
          {x: '6', y: 7},
          {x: '7', y: 6},
          {x: '8', y: 3},
          {x: '9', y: 2},
          {x: '> 10', y: 0}
          ];

          return (
            <Nav.Link>
            <Card className = 'p-0'
              bg={this.props.colour}>
              <Card.Title className='p-4 text-center'>Pending Templates by Age (Days)</Card.Title>
              <Card.Body className = 'p-2'>
                <Row>
                  <XYPlot height={300} width={480} xType="ordinal">
                      <VerticalBarSeries data={data} 
                        color='#82c9f4'
                      />
                      <HorizontalGridLines />
                      <XAxis position="middle"/>
                      <YAxis />
                  </XYPlot>
                </Row>
              </Card.Body>
            </Card>
          </Nav.Link>
            );
      }
  
  }
  
  const mapStateToProps = (state) => {
      return{
          fetchingData: state.fetchingData === true
      };
  }
  
  export default connect(
      // map state to props
      mapStateToProps, 
      // map dispatch to props
      (dispatch, ownProps) => ({
  
        })
      )(LineChart);